const SignUpUid = {
  Partner: 'partner-signup',
  D2C: 'd2c-signup',
};

export default SignUpUid;
